import React from 'react';
import { useSelector } from 'react-redux';
import { StyledContainer, StyledText } from './styles';
import { LinearProgress } from '@mui/material';
import { breakpoints } from '@tphglobal/common/theme/style.layout';
import useWindowSize from '@tphglobal/common/hooks/windowSize';

const Loader = () => {
  const loaderState = useSelector((state: any) => state.loader);
  const { width } = useWindowSize();
  const isMobile = width <= breakpoints.mobile;
  return (
    loaderState.visibility && (
      <StyledContainer width={isMobile ? '40%' : '20%'} >
        <StyledText variant={isMobile ? 'h6' : 'h5'}>
          Loading . . .
        </StyledText>
        <LinearProgress
          sx={{
            width: '30%',
          }}
        />
      </StyledContainer>
    )
  );
};

export default Loader;